import { TextField, FormControl } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CommonToolTip from "./Tooltip";
const useStyle = makeStyles((theme) => ({
  iih_input_cls: {
    marginTop: "20px !important",
    width: "100%",
    display: "block",
    "&>div": {
      width: "100%",
      "&>p": {
        margin: 0,
        fontSize: 12,
        lineHeight: "22px",
        display: "flex",
      },
      "&>div": {
        "&>p": {
          marginLeft: "0px",
          color: "#FF0000",
        },
        "&>div": {
          // borderRadius:"12px",
          "&>div": {
            "&>button": {
              marginTop: "10px",
            },
          },
        },
      },
    },
  },
  "@global": {
    ".MuiAutocomplete-root .Mui-disabled, .MuiTextField-root .Mui-disabled": {
      "-webkit-text-fill-color": "#282828 !important",
      color: "#282828 !important",
    },
  },
}));

export default function CommonTexField({
  required = false,
  disabled = false,
  type = "text",
  defaultValue,
  error = false,
  helperText,
  multiline = false,
  maxRows,
  placeholder,
  rows,
  startAdornment = "",
  endAdornment,
  readOnly = false,
  isloading = false,
  sx,
  value = "",
  label = "",
  tooltip = "",
  max,
  ...props
}) {
  const classes = useStyle();

  const sanitizedValue =
    typeof value === "string" ? value.replace(/(<([^>]+)>)/gi, "") : value;

  return (
    <div className={classes.iih_input_cls}>
      <FormControl>
        <CommonToolTip title={tooltip}>
          <p style={{ fontSize: "15px" }}>
            {label}{" "}
            {required && (
              <span style={{ color: "red", marginLeft: "5px" }}>*</span>
            )}
          </p>
        </CommonToolTip>
        <TextField
          variant="outlined"
          type={type}
          required={required}
          disabled={isloading || disabled}
          defaultValue={defaultValue}
          error={error}
          helperText={helperText}
          multiline={multiline}
          maxRows={maxRows}
          placeholder={placeholder}
          rows={rows}
          size="small"
          value={sanitizedValue}
          readOnly={readOnly}
          InputProps={{
            readOnly: true,
          }}
          inputProps={{ readOnly, max }}
          {...props}
        ></TextField>
      </FormControl>
    </div>
  );
}
